import { injectToolCSS } from "../utils/cssGenerator";
import IToolConfig from "../types/IToolConfig";
import { ALL_ELEMENT_SELECTORS, TEXT_SELECTORS } from "../enum/Selectors";

// Declare the global interface for assets
declare global {
  interface Window {
    _cyA11yAssets?: {
      fonts?: string;
    };
  }
}

export const readableFontConfig: IToolConfig = {
    id: "readable-font",
    selector: `html`,
    childrenSelector: [...ALL_ELEMENT_SELECTORS, ...TEXT_SELECTORS],
    styles: {
        'font-family': 'OpenDyslexic3,Comic Sans MS,Arial,Helvetica,sans-serif'
    },
    css: `@font-face {font-family: OpenDyslexic3;src: url("${window._cyA11yAssets?.fonts}OpenDyslexic3-Regular.woff") format("woff"), url("${window._cyA11yAssets?.fonts}OpenDyslexic3-Regular.ttf") format("truetype");}`
}

export default function readableFont(enable=false) {
    injectToolCSS({
        ...readableFontConfig,
        enable
    })
}